<template>
  <div class="is-flex is-align-items-center">
    <select class="select" :disabled="isSaving" @change="onChange">
      <option :selected="selectedUser === ''" :value="''">Select user</option>
      <option v-for="user in users" :key="user" :selected="user === selectedUser">
        {{ user }}
      </option>
    </select>
    <span class="tag" style="font-size: 0.6rem">{{ this.actionList.length }}</span>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TasksScreenManager } from '@/logic/TasksScreen'
import request from '@/requests'
import { mapWithConcurrency } from '@/util'
import { MAX_CONCURRENT_BULK_ACTIONS } from '@/constants'
import type MasterItem from '@/logic/TasksScreen/MasterItem'

import type { Action, TaskTypeKey } from '@/interfaces'

interface StoredAction {
  item: MasterItem
  callback: Function
  action: Action
  taskType: TaskTypeKey
}

@Component({})
export default class UserSelect extends Vue {
  @Prop({}) actionList!: Array<StoredAction>
  @Prop({}) manager!: TasksScreenManager
  @Prop({}) masterItem!: MasterItem
  @Prop({}) updateActions!: Function

  protected userOptions = this.users

  protected selectedUser = ''

  // Blocks a new selection while the previous one is still being saved: every
  // change is a PUT plus a refresh for each selected address
  protected isSaving = false

  get users() {
    const users = [...(this.actionList[0].action.data as Array<string>)]
    return users.sort((a, b) => a.localeCompare(b))
  }

  protected onChange = async (event: InputEvent) => {
    const target = event.target as HTMLSelectElement

    this.selectedUser = target.value
    this.updateSelection(this.selectedUser)

    // Sales has no url on user_select: the user only travels with the action
    // itself, so there is nothing to save or refresh (this used to PUT
    // api/v1/undefined for every address)
    if (!this.actionList[0].action.url) {
      this.updateActions()
      return
    }

    this.isSaving = true
    try {
      await this.updateTaskDetails()
      await this.manager.updateListForAddresses(this.actionList.map(({ item }) => item.address))
    } finally {
      this.isSaving = false
    }

    this.updateActions()
  }

  protected updateSelection(user: string) {
    this.manager.setActionDataForItems({ userToApprove: user }, this.actionList)
  }

  protected async updateTaskDetails() {
    await mapWithConcurrency(this.actionList, MAX_CONCURRENT_BULK_ACTIONS, (entry) =>
      request.details.updateTaskDetailForClient(`api/v1/${entry.action.url}`, entry.item.actionData)
    )
  }

  // mounted() {
  //   this.updateSelection(this.selectedUser);
  // }
}
</script>

<style lang="scss" scoped>
.select {
  margin-right: 5px;
  font-size: 10px;
  height: 14px !important;
}
</style>
